import React, { useState } from 'react';
import '../../App.css';
import '../../Styles/Admins/Admin-login.css';
import { toast } from 'react-toastify';
import { sendOtpToDelete, verifyOtpToDelete } from '../../services/deleteUserService';
import Swal from 'sweetalert2';

function DeleteUserAct() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [reason, setReason] = useState('');
    const [verificationSID, setVerificationSID] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let reqObj = {
            phoneNumber: mobileNumber,
            sid: verificationSID,
            code: otp,
            reasonForDeletion: reason
        }
        const verifyOtpData = await verifyOtpToDelete(reqObj);
        if (verifyOtpData) {
            // toast.success(verifyOtpData.message);
            Swal.fire({
                title: 'Success!',
                text: verifyOtpData.message,
                icon: 'success',
                confirmButtonText: 'OK',
            });
            // Clear fields
            setFirstName('');
            setLastName('');
            setMobileNumber('');
            setOtp('');
            setReason('');
            setOtpSent(false);
            setIsChecked(false)
        }
        else {
            toast.error('Invalid OTP')
        }
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        const reqObj = { phoneNumber: mobileNumber };

        setIsLoading(true); // Indicate loading
        try {
            const otpData = await sendOtpToDelete(reqObj);
            if (otpData?.verificationStatus?.includes("Success")) {
                toast.success(otpData?.verificationStatus);
                setVerificationSID(otpData.verificationSID);
                setOtpSent(true);
            } else {
                toast.error('User not found');
            }
        } catch (error) {
            toast.error('Failed to send OTP. Please try again.');
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    // Handle checkbox change
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };


    return (
        <div className="flex justify-center items-center bg-gray-100">
            <div className="w-8/12 max-w-s bg-white p-4 rounded-lg shadow-lg">
                <div className="text-center font-bold text-2xl mb-3">Delete User Account</div>
                <form onSubmit={handleSubmit}>
                    <div className="flex mb-2">
                        <div className="w-1/2 pr-2">
                            <label htmlFor="firstName" className="block text-base font-medium">First Name</label>
                            <input
                                type="text"
                                id="firstName"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                className="w-full px-4 py-2 border rounded-md"
                                required
                            />
                        </div>
                        <div className="w-1/2 pl-2">
                            <label htmlFor="lastName" className="block text-base font-medium">Last Name</label>
                            <input
                                type="text"
                                id="lastName"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                className="w-full px-4 py-2 border rounded-md"
                                required
                            />
                        </div>
                    </div>

                    <div className="mb-2">
                        <label htmlFor="mobileNumber" className="block text-base font-medium">Mobile Number</label>
                        <div className="flex items-center space-x-4">
                            {/* Mobile Number Input */}
                            <input
                                type="text"
                                id="mobileNumber"
                                value={mobileNumber}
                                minLength={10}
                                maxLength={10}
                                onChange={(e) => {
                                    const updatedValue = e.target.value.replace(/\D/g, '');
                                    setMobileNumber(updatedValue);

                                    // Reset OTP state if mobile number changes
                                    if (updatedValue.length !== 10) {
                                        setOtpSent(false);
                                    }
                                }}
                                className="flex-1 px-4 py-2 border rounded-md"
                                required
                            />

                            {/* Conditional Rendering */}
                            {!otpSent ? (
                                // Get OTP Button
                                <button
                                    type="button"
                                    onClick={handleSendOtp}
                                    className={`px-4 py-2 ${mobileNumber.length === 10
                                        ? 'otp-button text-white rounded-md'
                                        : 'bg-gray-300 text-gray-600 rounded-md cursor-not-allowed'
                                        }`}
                                    disabled={isLoading || mobileNumber.length !== 10}
                                >
                                    {isLoading ? 'Sending...' : 'Get OTP'}
                                </button>
                            ) : (
                                // OTP Input Field
                                <input
                                    type="text"
                                    id="otp"
                                    value={otp}
                                    minLength={6}
                                    maxLength={6}
                                    onChange={(e) => setOtp(e.target.value)}
                                    className="flex-1 px-4 py-2 border rounded-md"
                                    placeholder="Enter OTP"
                                    required
                                />
                            )}
                        </div>
                    </div>



                    <div className="mb-2">
                        <label htmlFor="reason" className="block text-base font-medium">Reason</label>
                        <textarea
                            id="reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            className="w-full border p-2 rounded-md"
                            required
                        ></textarea>
                    </div>

                    {/* Information List */}
                    <div className="mb-2">
                        <label htmlFor="informationList" className="block text-lg font-bold mb-1">Before you proceed with your account deletion request, please review the following important information:</label>
                        <div className='px-3'>
                            <li><span className='font-bold'>Data Loss :</span> All personal information, health records, activity history, and other saved data associated with your account will be permanently deleted and cannot be recovered.</li>
                            <li><span className='font-bold'>Subscription Cancellation :</span> If you have any active subscriptions, they will be canceled. Refunds may not be available, as per the terms of service.</li>
                            <li><span className='font-bold'>Impact on Access :</span> You will lose access to all app features and services, including any purchased or saved content.</li>
                        </div>
                    </div>
                    <div className='mt-3 flex items-center'>
                        <input className="w-5 h-5"
                            type='checkbox'
                            id='checkbox'
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        <label className='ml-2'>I have read and understood the implications of deleting my account.</label>
                    </div>

                    <div className="mt-3 text-center">
                        <button
                            className="px-6 py-2 otp-button text-white rounded-md"
                            type="submit" disabled={!isChecked}>
                            Submit
                        </button>
                    </div>
                </form>

                {/* <Modal
                    open={showModal}
                    onClose={() => setShowModal(false)}
                >
                    <Box
                        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg"
                        sx={{ width: 400 }}
                    >
                        <Typography variant="h6" className="mb-4">
                            Confirm Submission
                        </Typography>
                        <Typography className="mb-6">
                            Are you sure you want to proceed with deleting your account?
                        </Typography>
                        <div className="flex justify-end gap-4">
                            <button className="px-6 py-2 bg-gray-300 rounded-md" onClick={cancelSubmit}>
                                Cancel
                            </button>
                            <button className="px-6 py-2 otp-button text-white rounded-md" onClick={confirmSubmit}>
                                Confirm
                            </button>
                        </div>
                    </Box>
                </Modal> */}
            </div>
        </div>
    );
}

export default DeleteUserAct;
